import type { SearchEntity } from "src/queries/search/search.types";
import type {
  AppPath,
  ClusterPath,
  DatasetPath,
  TaskPath,
} from "src/utils/appRoutes/appRoutes.types";
import { buildLink } from "src/utils/buildLink/buildLink";

export function getEntityUrl(entity: SearchEntity): string | undefined {
  const env_name = entity.payload.env_name;

  switch (entity.type) {
    case "pipeline":
      return buildLink(env_name, {
        app_name: entity.payload.app_name,
      } as AppPath);

    case "compute":
      return buildLink(env_name, {
        app_name: entity.payload.app_name,
        cluster_name: (entity.payload as any).task_name,
      } as ClusterPath);

    case "task":
      return buildLink(env_name, {
        app_name: entity.payload.app_name,
        task_name: (entity.payload as any).task_name as string,
      } as TaskPath);

    case "dataset":
      return buildLink(env_name, {
        dataset: entity.name,
      } as DatasetPath);

    default:
      return undefined;
  }
}
